<!--
  ArchivedStoreBanner.vue

  The editor's notice on an ARCHIVED store, which opens in a restricted,
  Batches-only mode (Jake, 2026-10-20; option 2 of
  docs/planning/2026-10-16-batch-controls-and-archived-stores-proposal.md).

  It says why every other section is gone and carries the one way back:
  Unarchive. The same POST /stores/<id>/unarchive the Stores list uses; the
  store comes back CLOSED (or draft), reopened by the existing toggle, so
  unarchiving here never opens a store to shoppers.
-->
<template>
  <v-alert
    type="info"
    variant="tonal"
    density="comfortable"
    class="mb-4 archived-store-banner"
    data-testid="archived-store-banner"
  >
    <div class="archived-store-banner__row">
      <div class="archived-store-banner__copy">
        <strong>{{ storeName || "This store" }} is archived.</strong>
        Shoppers can't reach it and it can't be edited, but you can still
        manage its batches here. Unarchive it to edit the store again; it comes
        back closed.
        <div
          v-if="error"
          class="archived-store-banner__error"
          role="alert"
          data-testid="archived-unarchive-error"
        >
          {{ error }}
        </div>
      </div>
      <v-btn
        color="primary"
        variant="flat"
        :loading="pending"
        :disabled="pending"
        data-testid="archived-unarchive-btn"
        @click="unarchive"
      >
        Unarchive
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
import { notifyStoreArchiveChanged } from "@/stores/sidebarRefresh";

export default {
  name: "ArchivedStoreBanner",
  props: {
    storeId: { type: [String, Number], required: true },
    storeName: { type: String, default: "" },
  },
  emits: ["unarchived"],
  data() {
    return { pending: false, error: "" };
  },
  methods: {
    async unarchive() {
      if (this.pending) return;
      this.pending = true;
      this.error = "";
      try {
        await this.$axios.post(`/stores/${this.storeId}/unarchive`);
      } catch (err) {
        this.error = "Could not unarchive this store. Nothing changed.";
        this.pending = false;
        return;
      }
      this.pending = false;
      // The sidebar's store count follows the archive state.
      notifyStoreArchiveChanged();
      this.$emit("unarchived");
    },
  },
};
</script>

<style scoped>
.archived-store-banner__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.archived-store-banner__copy {
  flex: 1;
}
.archived-store-banner__error {
  margin-top: 6px;
  color: var(--tf-danger, #b3261e);
}
</style>
